import { WhatsAppIcon } from '../icons/WhatsAppIcon';

import { Logo } from './Logo';
import { CartButton } from './CartButton';
import { buildWaLink } from 'features/misc/api/getProducts';

const NAV_LINKS = [
  { label: 'Shop', href: 'shop' },
  { label: 'How it works', href: '#how' },
  { label: 'Contact', href: '#contact' },
];

export function Navbar() {
  return (
    <nav className="sticky top-0 z-50 flex h-16 items-center justify-between border-b border-white/10 bg-bg/90 px-4 backdrop-blur-md sm:px-8">
      <a href="/" className="shrink-0">
        <Logo />
      </a>

      <div className="hidden gap-8 sm:flex">
        {NAV_LINKS.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="text-sm font-semibold text-text-muted transition-colors hover:text-text"
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="flex items-center gap-3">
        <CartButton />

        <a
          href={buildWaLink('Hi Chikwafu, I want to order a gadget')}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 rounded-full bg-accent px-4 py-2 text-sm font-extrabold text-black transition-all hover:-translate-y-px hover:bg-accent-dim"
        >
          <WhatsAppIcon />
          <span className="hidden sm:inline">Chat on WhatsApp</span>
          <span className="sm:hidden">Chat</span>
        </a>
      </div>
    </nav>
  );
}
